export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11163_LAUNCH_CHAT_MENU': 'Launch chat menu'
};
